import ActionType from '../ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'
import listSelector from 'components/ListView/listSelector'
import { selectContact } from './addOrEdit'

export const getAllGroups = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({ type: ActionType.Contacts.GET_ALL_GROUPS_REQUEST })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/contactgroup`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.LIST_FAILURE,
                payload,
                entityType: 'contactgroup',
                notOk: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Contacts.GET_ALL_GROUPS_SUCCESS,
              payload,
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Data.LIST_FAILURE,
              payload: error,
              entityType: 'contactgroup',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const getGroup = groupID => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    dispatch({
      type: ActionType.Contacts.GET_GROUP_REQUEST,
      payload: { groupID },
    })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/contactgroup/${groupID}`, {
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.READ_FAILURE,
                payload,
                entityType: 'contactgroup',
                notOk: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Contacts.GET_GROUP_SUCCESS,
              payload: { memberIDs: payload.contact_ids, groupID, ...payload },
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Contacts.READ_FAILURE,
              payload: error,
              groupID,
              entityType: 'contactgroup',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const createGroup =
  (name, contact_ids = []) =>
  (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const data = { name, contact_ids }

      dispatch({
        type: ActionType.Contacts.CREATE_GROUP_REQUEST,
        payload: data,
      })

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/contactgroup`, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Data.CREATE_FAILURE,
                  payload,
                  entityType: 'contactgroup',
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Contacts.CREATE_GROUP_SUCCESS,
                payload,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Data.CREATE_FAILURE,
                payload: error,
                entityType: 'contactgroup',
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

export const renameGroup = (id, name) => (dispatch, getState) => {
  dispatch({
    type: ActionType.Contacts.RENAME_GROUP_REQUEST,
    payload: { id, name },
  })

  const data = { name }
  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/contactgroup/${id}`, {
        body: JSON.stringify(data), // must match 'Content-Type' header
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'PUT', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res =>
          res.json().then(data => {
            if (!res.ok) {
              return { notOk: true, ...data }
            }
            return data
          }),
        )
        .then(payload =>
          payload && payload.notOk
            ? dispatch({
                type: ActionType.Data.UPDATE_FAILURE,
                payload,
                entityType: 'contactgroup',
                notOk: true,
              })
            : dispatch({
                type: ActionType.Contacts.RENAME_GROUP_SUCCESS,
                payload,
              }),
        )
        .catch(error =>
          dispatch({
            type: ActionType.Data.UPDATE_FAILURE,
            payload: error,
            entityType: 'contactgroup',
          }),
        )
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const selectAllContacts = () => (dispatch, getState) => {
  const memberIDs = getState().addOrEditContact.memberIDs
  const campaign = getState().campaign
  const contactIDsInStagesByCampaignID = campaign.contactIDsInStagesByCampaignID
  // console.log('contactIDs', contactIDsInStagesByCampaignID)
  const campaignID = campaign.addOrEdit.campaign?.id
  const stageID = campaign.addOrEdit.stageSelectedForContactView?.id

  const list = memberIDs?.length
    ? memberIDs.map(id => ({ id }))
    : Object.keys(contactIDsInStagesByCampaignID || {}).length
    ? contactIDsInStagesByCampaignID?.[campaignID]?.[stageID]?.map(id => ({
        id,
      }))
    : listSelector(getState(), {
        endpoint: 'contact',
        listState: state => state.contacts.contactsWithEmailsByID,
        loadStatus: state => state.loadStatus.contacts,
        keys: {
          sortable: ['first_name', 'middle_name', 'last_name', 'location'],
          nonSortable: ['email.address', 'phones.number'],
        },
      })

  return dispatch(selectContact(list, true))
}

export const addContactsToGroup = (contacts, groupID) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const name =
      getState().contacts.groupsByID?.[groupID]?.name ||
      getState().contacts.renameGroupFieldValue

    const data = { id: groupID, contact_ids: Object.keys(contacts), name }

    dispatch({
      type: ActionType.Contacts.ADD_CONTACTS_TO_GROUP_REQUEST,
      payload: { contacts, groupID, name },
    })

    return Auth.currentSession()
      .then(session => {
        const headerValue = `Bearer ${session.idToken.jwtToken}`

        return fetch(`${API_URL}/contactgroup/${groupID}/addMembers`, {
          body: JSON.stringify(data), // must match 'Content-Type' header
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          headers: {
            'content-type': 'application/json',
            authorization: headerValue,
          },
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, cors, *same-origin
          redirect: 'follow', // manual, *follow, error
          referrer: 'no-referrer', // *client, no-referrer
        })
          .then(res =>
            res.json().then(data => {
              if (!res.ok) {
                return { notOk: true, ...data }
              }
              return data
            }),
          )
          .then(payload => {
            if (payload && payload.notOk) {
              dispatch({
                type: ActionType.Data.UPDATE_FAILURE,
                payload,
                entityType: 'contactgroup',
                notOk: true,
              })
              reject(payload)
              return
            }

            dispatch({
              type: ActionType.Contacts.ADD_CONTACTS_TO_GROUP_SUCCESS,
              payload,
              data,
              contacts,
              groupID,
              name,
            })
            resolve(payload)
          })
          .catch(error => {
            dispatch({
              type: ActionType.Data.UPDATE_FAILURE,
              payload: error,
              entityType: 'contactgroup',
            })
            reject(error)
          })
      })
      .catch(err => {
        console.log(err)
        if (err.code === 'UserNotFoundException') {
          window.localStorage.clear()
          window.location.reload(true)
        }
      })
  })

export const removeContactsFromGroup =
  (contacts, groupID) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const name = getState().contacts.groupsByID?.[groupID]?.name

      dispatch({
        type: ActionType.Contacts.REMOVE_CONTACTS_FROM_GROUP_REQUEST,
        payload: { contacts, groupID },
      })

      const data = { id: groupID, contact_ids: Object.keys(contacts), name }
      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/contactgroup/${groupID}/removeMembers`, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Data.UPDATE_FAILURE,
                  payload,
                  entityType: 'contactgroup',
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Contacts.REMOVE_CONTACTS_FROM_GROUP_SUCCESS,
                payload,
              })
              resolve(payload)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Data.UPDATE_FAILURE,
                payload: error,
                entityType: 'contactgroup',
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
    })

export const deleteGroup = id => (dispatch, getState) => {
  dispatch({
    type: ActionType.Contacts.DELETE_GROUP_REQUEST,
    payload: id,
  })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/contactgroup/${id}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'content-type': 'application/json',
          authorization: headerValue,
        },
        method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res =>
          res.json().then(data => {
            if (!res.ok) {
              return { notOk: true, ...data }
            }
            return data
          }),
        )
        .then(payload => {
          if (payload && payload.notOk) {
            dispatch({
              type: ActionType.Data.DELETE_FAILURE,
              payload,
              entityType: 'contactgroup',
              notOk: true,
            })
            return
          }

          dispatch({
            type: ActionType.Contacts.DELETE_GROUP_SUCCESS,
            payload,
            id,
          })
        })
        .catch(error =>
          dispatch({
            type: ActionType.Data.DELETE_FAILURE,
            payload: error,
            entityType: 'contactgroup',
          }),
        )
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const handleGroupNameChange = payload => dispatch => {
  dispatch({
    type: ActionType.Contacts.HANDLE_RENAME_GROUP_FIELD_CHANGE,
    payload,
  })
}

export const toggleGroupDialog = payload => dispatch => {
  dispatch({
    type: ActionType.Contacts.TOGGLE_GROUP_DIALOG,
    payload,
  })
}
